module.exports = __webpack_public_path__ + "static/right.71bd57c7.svg";